import firebase from "firebase/app";
import "firebase/functions";
import { db } from "../../../db.js";
import { ERROR_REPLY } from "./helpChatUnread.mjs";

const inflight = new Set();

function persistedMessages(conversation) {
  const messages = conversation?.Messages;
  if (!Array.isArray(messages)) return [];
  return messages.filter((message) => message && typeof message === "object");
}

/**
 * Ask Help Chat to reply. The callable keeps running after the chat modal
 * closes or the user leaves the page, and a failed call is still stored on
 * the conversation.
 */
/** Keep a record page. The help chat's own route is not context for a question. */
export function helpChatRoute(path) {
  if (typeof path !== "string") return "";
  const route = path.trim();
  if (!route.startsWith("/") || route.startsWith("/Home/HelpChat")) return "";
  return route.slice(0, 300);
}

export function requestHelpReply({ store, conversationId, conversationPath, databaseURL, route = "" }) {
  const helpChatCallable = firebase.app().functions().httpsCallable("helpChat", { timeout: 300000 });
  let pending;
  pending = (async () => {
    try {
      const page = helpChatRoute(route);
      const result = await helpChatCallable({
        conversationId,
        databaseURL,
        locale: navigator.language,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...(page ? { route: page } : {}),
      });
      console.log("[HelpChat] Successfully called helpChat function", result.data);
      return true;
    } catch (error) {
      console.error("[HelpChat] Error calling helpChat function:", error);
      const messages = persistedMessages(store.state.helpChatList?.[conversationId]);
      const last = messages[messages.length - 1];
      if (last?.Role === "bot" || !conversationPath) return false;
      try {
        await db.update(conversationPath, {
          Messages: [
            ...messages,
            {
              Role: "bot",
              Message: ERROR_REPLY,
              Time: new Date().toISOString(),
            },
          ],
        });
      } catch (writeError) {
        console.error("[HelpChat] Could not store the error reply", writeError);
      }
      return false;
    } finally {
      inflight.delete(pending);
    }
  })();

  inflight.add(pending);
  return pending;
}
